import { ComponentStyleProps } from "../../../../../../../../lib/styles/props/component-style-props";
import { CMFormInputDate } from "@pscsrvlab/psc-react-components";
import React, { memo } from "react";
import { FormSection } from "../../../../../../../ui/form/FormSection/FormSection";
import { useAppTranslation } from "../../../../../../../../hooks/use-app-translation";

export type NewApplicationSubmissionDateCreateProjectSectionProps = {
  editMode: "editable" | "readOnly";

  /**
   * 値。
   */
  value?: { year: number; month: number; day: number };
  onChange: (value: { year: number; month: number; day: number }) => void;
} & ComponentStyleProps;

/**
 * 新規申請提出日セクション
 */
export const NewApplicationSubmissionDateCreateProjectSection = memo(
  function NewApplicationSubmissionDateCreateProjectSection({
    editMode,

    value,
    onChange,

    sx,
    ...rest
  }: NewApplicationSubmissionDateCreateProjectSectionProps) {
    const { t } = useAppTranslation();

    return (
      <FormSection title={t("lbl.新規申請提出日")} sx={sx} {...rest}>
        <CMFormInputDate
          editMode={editMode}
          value={value}
          onChange={onChange}
          sx={{ w: "200px" }}
        />
      </FormSection>
    );
  },
);
